import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import StyledForgetPassword from "./StyledForgetPassword";
import { BUTTON_LABELS, INPUT_LABELS } from "../../constants/lang";
import { Controller, useForm } from "react-hook-form";
import TextFeild from "../../components/CommonComponents/TextFeild";
import { forgetPasswordSchema } from "../../schema/forgetPasswordSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate } from "react-router-dom";
import { fetchForgetPassword } from "../../store/reducers/authentication";
import { useDispatch } from "react-redux";
import { ToastNotifyError, ToastNotifySuccess } from "../../components/CommonComponents/Toast/ToastNotify";
import { ROUTE_PATH } from "../../constants/route";
import rollbar from "../../rollbarConfig";

const { LOGIN } = ROUTE_PATH;

const ForgetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(forgetPasswordSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await dispatch(fetchForgetPassword(data));
      const { status, message } = response?.payload || {};

      if (status === true) {
        ToastNotifySuccess(message);
        navigate(ROUTE_PATH.FORGET_PASSWORD_CHECK_INBOX, {state: {data}})
        reset();
      } else if (status === 400) {
        ToastNotifyError(response?.payload?.response?.data?.message || 'An error occurred. Please try again.');
      } else {
        ToastNotifyError('An error occurred. Please try again.');
      }
    } catch (error) {
      ToastNotifyError("An error occurred. Please try again.");
      rollbar.error("Error message", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <StyledForgetPassword>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        className="forgetpass-wrap"
      >
        <Typography className="forgetpass-header">Forgot Password</Typography>
        <Typography className="forgetpass-sub-header">
          A reset link will be sent to you on your email
        </Typography>
        <Box className="forgetPass-textfeilds">
          <Box className="signup-email">
            <Controller
              name="email"
              control={control}
              className="email-feild"
              defaultValue=""
              render={({ field }) => (
                <TextFeild
                  label={INPUT_LABELS.email}
                  placeholder="Enter your email"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  error={!!errors.email}
                  helperText={errors.email?.message}
                  {...field}
                />
              )}
            />
          </Box>
        </Box>
        <Button
          isLoading={isLoading}
          disabled={isLoading}
          type="submit"
          variant="contained"
          color="primary"
          sx={{
            width: "100%",
            padding: "10px",
            marginTop: "24px",
            fontSize: "16px",
            textTransform: "none",
          }}
        >
          {BUTTON_LABELS.SUBMIT}
        </Button>
        <Box className="backLogin">
          <Link to={LOGIN} aria-label="login button">
            {BUTTON_LABELS.BACK_TO_LOGIN}
          </Link>
        </Box>
      </Box>
    </StyledForgetPassword>
  );
};

export default ForgetPassword;
